import { useThemeContext } from '@tribeplatform/react-ui-kit/ThemeProvider'

import { PickerIconData } from '../types.js'
import { getPickerIconSpriteUrl } from '../utils/picker.utils.js'

export const IconPickerIcon = ({ icon }: { icon: PickerIconData }) => {
  const { assets } = useThemeContext()
  const iconUrl = getPickerIconSpriteUrl(icon.pack, assets)

  return (
    <span
      className="h-6 w-6"
      style={{
        maskImage: `url(${iconUrl})`,
        WebkitMaskImage: `url(${iconUrl})`,
        backgroundColor: 'currentColor',
        maskPosition: icon.maskPosition,
        WebkitMaskPosition: icon.maskPosition,
      }}
    />
  )
}
